import { API_BASE_URL } from '../config/config';

/**
 * Función para hacer peticiones HTTP al backend usando fetch.
 * Agrega el token automáticamente si existe.
 * Detecta si se usa FormData y no sobreescribe el Content-Type.
 *
 * @param {string} endpoint - Ruta del endpoint, por ejemplo: '/actas'
 * @param {object} options - Opciones adicionales para fetch (method, body, headers...)
 * @returns {Promise<any>} - Respuesta en formato JSON o texto plano
 */
export const apiFetch = async (endpoint, options = {}) => {
  try {
    const token = localStorage.getItem('token');
    const isFormData = options.body instanceof FormData;

    const headers = {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      ...(options.headers || {}),
    };

    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      credentials: 'include',
      headers,
      ...options,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `Error ${response.status}`);
    }

    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      return await response.json();
    } else {
      return await response.text(); // fallback si no es JSON
    }
  } catch (error) {
    console.error('Error en apiFetch:', error.message);
    throw error;
  }
};
